@if (loaded) {
  <app-search-sidenav #searchSidenav>
    @if (catalogs) {
      <div class="col-12 text-center scrollbar-visible p-0">
        <cdk-virtual-scroll-viewport class="h-100"
          itemSize="100">
          <div class="padding-catalog">
            <div class="page-header"><span>{{'pages.catalogList.header' | translate }}</span></div>
            <div class="filter-bar">
              <button (click)="searchSidenav.openMenu()" class="btn button-filter">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9">
                  <g clip-path="url(#clip0_103_1822)">
                    <path d="M0 7H4" stroke="black" stroke-miterlimit="10"/>
                    <path d="M6 7H14" stroke="black" stroke-miterlimit="10"/>
                    <path d="M4 9V5" stroke="black" stroke-miterlimit="10"/>
                    <path d="M14 2H10" stroke="black" stroke-miterlimit="10"/>
                    <path d="M8 2H0" stroke="black" stroke-miterlimit="10"/>
                    <path d="M10 0V4" stroke="black" stroke-miterlimit="10"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_103_1822">
                      <rect width="14" height="9" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span class="header-buttons-label">{{'pages.catalogList.filters' | translate }}</span>
              </button>
            </div>
            <div class="align-items-center-middle">
              @if (isCopyingConfiguration()) {
                <div class="copying-container">
                  <div class="copying-label"> {{ 'SELECT_TO_COPY' | translate }}
                    <span class="copying-label-cancel" (click)="cancelCopyingConfiguration()">{{'ANNULLA' | translate}}</span>
                  </div>
                </div>
              }
      </div>
      @if (loaded) {
        <div class="iubenda-padding">
          @for (catalog of catalogs; track catalog; let i = $index) {
            <div class="px-xl-5 catalog category-bb" [ngClass]="{'category-bt': selectedId == i}">
              <div class="category-header">
                <span class="category-name">{{catalog.categoryName | titlecase}}</span>
                <div class="category-action">
                  <button class="action-see-all" (click)="catalogDetail(catalog.categoryId)"><span>{{ 'pages.catalogList.seeAll' | translate}}</span></button>
                </div>
              </div>
              @if (catalog.productModels.length > 0) {
                <div class="d-flex m-0 pt-3 product-models"
                  >
                  <!--              <div class="col-sm-2 pl-0 pr-0">-->
                  <!--                <div class="category-margin-left">-->
                  <!--                  <h2 class="category-name" (click)="catalogDetail(catalog.categoryId)">{{catalog.categoryName}}</h2>-->
                <!--                </div>-->
              <!--              </div>-->
              @for (model of catalog.productModels; track model; let i = $index) {
                <div (click)="modelDetail(model.modelId, catalog.categoryId)"
                  class="col-lg-3 col-sm-6 model">
                  @if (shouldIndexBeVisible(i)) {
                    <img [hidden]="!model.imageLoaded"
                      (load)="imageLoaded(model)"
                      [alt]="model.modelName"
                      [src]="convertProductImage(model)"
                      (error)="convertProductImage(model, true)"
                      class="model-image"/>
                    @if (!model.imageLoaded) {
                      <app-loading [isBlock]="true" width="75%" height="auto" class="model-image"></app-loading>
                    }
                    <p class="model-name">{{model.modelName | titlecase}}</p>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
  @if (!loaded) {
    <app-visionnaire-loader class="ipe:w-full" />
  }
</div>
</cdk-virtual-scroll-viewport>
<!--          <button (click)="increasePagination()" *ngIf="overflow" class="btn-primary">MOSTRA DI PIÙ</button>-->
</div>
}
</app-search-sidenav>
}
@if (!loaded) {
  <app-visionnaire-loader class="ipe:w-full" />
}
